import React, { useState } from "react";
import axios from "axios";
import SearchBar from "./components/SearchBar";
import WeatherCard from "./components/WeatherCard";
import "./App.css";

function App() {
  const [location, setLocation] = useState("");
  const [weatherData, setWeatherData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const API_KEY = process.env.REACT_APP_API_KEY;
  const API_URL = "https://api.openweathermap.org/data/2.5/weather";

  const fetchWeather = async (e) => {
    e.preventDefault();
    if (!location.trim()) return;

    setLoading(true);
    setError("");

    try {
      const response = await axios.get(API_URL, {
        params: {
          q: location.trim(),
          units: "metric",
          appid: API_KEY,
        },
      });
      setWeatherData(response.data);
      setError("");
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setError("City not found. Please check the spelling and try again.");
      } else {
        setError("Something went wrong. Please try again later.");
      }
      setWeatherData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="app">
      <div className="card">
        {/* Header */}
        <header className="app-header">
          <h1 className="app-title">
            <span className="app-title-icon" aria-hidden="true">⛅</span>
            Weather
          </h1>
          <p className="app-subtitle">Search any city worldwide</p>
        </header>

        {/* Search */}
        <SearchBar
          value={location}
          onChange={setLocation}
          onSubmit={fetchWeather}
          loading={loading}
        />

        {/* Error */}
        {error && (
          <div className="error-message" role="alert">
            <span className="error-icon" aria-hidden="true">⚠️</span>
            {error}
          </div>
        )}

        {/* Weather Results */}
        <section aria-live="polite" aria-label="Weather results">
          {weatherData ? (
            <WeatherCard data={weatherData} />
          ) : (
            !error && (
              <div className="empty-state">
                <div className="empty-state-icon" aria-hidden="true">🌍</div>
                <p className="empty-state-text">
                  Enter a city name to get<br />the current weather
                </p>
              </div>
            )
          )}
        </section>
      </div>
    </main>
  );
}

export default App;
